import { useQuery } from "@tanstack/react-query"
import { API } from "config"
import moment from "moment"

const useStockReport = () => useQuery({ queryKey: [`stock-report`], queryFn: async () => {
    const callback = await API.get(`/reports/stock`)
    return callback?.data
}, staleTime: 3000, gcTime: 1000 * 60 * 10 })

export default useStockReport